<template>
    <div class="list">
        <router-link class="item" v-for="(item, index) in data" :key="index" :to="`/news/detail?id=${item.id}`">
            <div class="cover" :style="`background-image: url(${item.image});`"></div>
            <div class="content">
                <div class="text">
                    <div class="title">{{item.title}}</div>
                    <div class="desc">{{item.introduction}}</div>
                </div>
                <div class="info">
                    <div class="time">{{item.time}}</div>
                    <div class="link">阅读全文</div>
                </div>
            </div>
        </router-link>
        <p class="load_text" v-if="isLoading">正在加载中…</p>
        <template v-else-if="page < total">
            <div class="more" @click="showMore">更多</div>
            <div class="more_arrow" @click="showMore"></div>
        </template>
        <p class="load_text" v-else>没有更多了</p>
    </div>
</template>

<script>
export default {
    name: "newsList",
    props: [ 'data', 'page', 'total', 'isLoading' ],
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        showMore(){
            this.$emit('showMore')
        }
    },
};
</script>

<style scoped lang="scss">
.load_text{
    text-align: center;
    color: rgba($color: #000000, $alpha: .5);
}
.list{
    padding-bottom: .5rem;
    .item{
        display: flex;
        margin-bottom: .6rem;
        .cover{
            width: 3.02rem;
            height: 1.54rem;
            border-radius: .04rem;
            background: no-repeat center/cover;
            margin-right: .36rem;
        }
        .content{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .title{
                line-height: 1;
                font-size: .2rem;
                margin-bottom: .15rem;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
            .desc{
                line-height: 1.8;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 3;
                /*! autoprefixer: off */
                -webkit-box-orient: vertical;
            }
            .info{
                display: flex;
                justify-content: space-between;
                align-items: center;
                .link{
                    border-bottom: 1px solid #000;
                }
            }
        }
    }
    .more{
        width: .92rem;
        height: .33rem;
        margin: 0 auto;
        border: 1px solid #dddddd;
        border-radius: .04rem;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .more_arrow{
        display: none;
    }
    @media only screen and (max-width: 1200px) {
        padding: 0 1rem 1.4rem;
        .item{
            margin-bottom: 1.1rem;
            .cover{
                width: 4.2rem;
                height: 2.8rem;
                border-radius: .05rem;
            }
            .content{
                .title{
                    font-size: .36rem;
                    text-decoration: underline;
                    -webkit-line-clamp: 2;
                    line-height: 1.6;
                }
                .desc{
                    font-size: .24rem;
                    -webkit-line-clamp: 2;
                }
                .info{
                    font-size: .24rem;
                    .link{
                        display: none;
                    }
                }
            }
        }
        .more{
            display: none;
        }
        .more_arrow{
            display: block;
            width: .48rem;
            height: .61rem;
            background: url('~@/assets/images/icon_arrow_next.svg') no-repeat 0/100%;
            margin: 0 auto;
            transform: rotate(90deg);
        }
    }
}
</style>